export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8305.8ca85a1a.jpg";